import { render } from "./BestPractiseView.vue?vue&type=template&id=32a80991"
import script from "./BestPractiseView.vue?vue&type=script&lang=js"
export * from "./BestPractiseView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__